import React, { useState, useEffect } from "react";
import { FaArrowLeft, FaFileExcel } from "react-icons/fa";
import NavBar from "../components/NavMenu";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const DetailClassSize = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const passedQuarters = location.state?.selectedQuarters || [
    "Q1 2025",
    "Q4 2024",
  ];
  const [selectedQuarters] = useState(passedQuarters);
  const [studentData, setStudentData] = useState([]);
  const [studentCount, setStudentCount] = useState(0);

  const parseQuarterYear = (quarterStr) => {
    const [qtr, year] = quarterStr.split(" ");
    return {
      qtr: parseInt(qtr.replace("Q", "")),
      year: parseInt(year),
    };
  };

  useEffect(() => {
    const fetchData = async () => {
      const { qtr, year } = parseQuarterYear(selectedQuarters[0]);

      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API}/getClassSizeByStudent?qtr=${qtr}&year=${year}`
        );

        // console.log("API response:", res.data);

        const current = res.data.current || [];
        setStudentData(current);
        setStudentCount(current.length);
      } catch (err) {
        console.error("Failed to fetch student data", err);
      }
    };

    fetchData();
  }, [selectedQuarters]);

  const handlePrevious = () => navigate(-1);

  return (
    <>
      <NavBar />
      <div
        style={{
          backgroundColor: "#373636",
          margin: 20,
          borderRadius: 10,
          padding: 30,
          minHeight: "calc(100vh - 80px)",
          color: "#fff",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 20,
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <FaArrowLeft size={18} onClick={handlePrevious} />
            <h4 style={{ margin: 0 }}>Class Size Details</h4>
            <span
              style={{
                background: "#444",
                padding: "6px 12px",
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 500,
              }}
            >
              {selectedQuarters[0]}
            </span>
            <span
              style={{
                background: "#444",
                padding: "6px 12px",
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 500,
              }}
            >
              Total Count: {studentCount}
            </span>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <button
              onClick={() => console.log("Export to Excel")}
              className="excel-button"
            >
              <FaFileExcel size={18} />
              Export to Excel
            </button>
          </div>
        </div>

        <div style={{ overflowX: "auto", borderRadius: 6 }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              backgroundColor: "#1f1f1f",
              borderRadius: 6,
              overflow: "hidden",
            }}
          >
            <thead style={{ backgroundColor: "#000" }}>
              <tr>
                <th style={thStyle}>STUDENT ID</th>
                <th style={thStyle}>NAME</th>
                <th style={thStyle}>COURSE CODE</th>
                <th style={thStyle}>COURSE LEVEL</th>
                <th style={thStyle}>STUDY MODE</th>
                <th style={thStyle}>FACULTY NAME</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(
                studentData.reduce((acc, item) => {
                  const sbu = item.sbu_name || "Unknown";
                  const course = item.course_code;

                  if (!acc[sbu]) acc[sbu] = {};
                  if (!acc[sbu][course]) acc[sbu][course] = [];

                  acc[sbu][course].push(item);
                  return acc;
                }, {})
              ).map(([sbu_name, courseGroups], groupIndex) => (
                <React.Fragment key={groupIndex}>
                  <tr>
                    <td colSpan={6} style={groupHeaderStyle}>
                      SBU: {sbu_name}
                    </td>
                  </tr>

                  {Object.entries(courseGroups).map(
                    ([courseCode, students], subIndex) => (
                      <React.Fragment key={`${sbu_name}-${courseCode}`}>
                        {students.map((row, i) => (
                          <tr
                            key={`${courseCode}-${i}`}
                            style={{
                              borderTop: "1px solid #444",
                              backgroundColor:
                                i % 2 === 0 ? "#2b2b2b" : "#252525",
                            }}
                          >
                            <td style={tdStyle}>{row.student_id}</td>
                            <td style={tdStyle}>{row.name}</td>
                            <td style={tdStyle}>{row.course_code}</td>
                            <td style={tdStyle}>{row.course_level}</td>
                            <td style={tdStyle}>{row.study_mode}</td>
                            <td style={tdStyle}>{row.faculty_name}</td>
                          </tr>
                        ))}

                        <tr
                          style={{
                            backgroundColor: "#1a1a1a",
                            borderTop: "1px solid #555",
                          }}
                        >
                          <td
                            colSpan={6}
                            style={{ ...tdStyle, textAlign: "right" }}
                          >
                            <span style={{ color: "#fff" }}>
                              Total Students in <span className="fw-bold">{courseCode} :</span>
                            </span>{" "}
                            <span
                              style={{
                                backgroundColor: "#ffa726",
                                color: "#000",
                                borderRadius: "12px",
                                padding: "4px 10px",
                                fontWeight: "bold",
                                fontSize: "13px",
                                display: "inline-block",
                                marginLeft: 8,
                                minWidth: 24,
                                textAlign: "center",
                              }}
                            >
                              {students.length}
                            </span>
                          </td>
                        </tr>
                      </React.Fragment>
                    )
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

const thStyle = {
  padding: "14px 12px",
  textAlign: "left",
  fontWeight: "bold",
  fontSize: 15,
  color: "#fff",
  borderBottom: "1px solid #444",
};

const tdStyle = {
  padding: "12px 12px",
  color: "#ddd",
  fontSize: 14,
};

const groupHeaderStyle = {
  backgroundColor: "#111",
  fontWeight: "bold",
  color: "#fff",
  padding: "10px 12px",
};

export default DetailClassSize;
